module.exports = __webpack_public_path__ + "static/team-13-721a8c6e70d6d2c74f001bbe8368dc80.jpg";